import { useQuery } from '@apollo/client';
import { GET_ACTIVE_CUSTOM_TARGET } from '../../../../graphql/OrgSettings.queries';

export const useQueryGetActiveCustomTarget = () => {
  const { data, loading } = useQuery(GET_ACTIVE_CUSTOM_TARGET, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    activeCustomTarget: data?.getActiveCustomTarget ?? undefined,
    isLoadingActiveCustomTarget: loading,
  };
};
